/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AccountInfo from '../components/AccountInfo';
import AddendaErrataSection from '../components/AddendaErrataSection';
import AddNewAddress from '../components/AddNewAddress';
import Auth from '../components/Auth';
import BackToTopButton from '../components/BackToTopButton';
import Cart from '../components/Cart';
import CartDisclaimer from '../components/CartDisclaimer';
import CartPage from '../components/CartPage';
import CartSlider from '../components/CartSlider';
import ChangePassword from '../components/ChangePassword';
import ChangePasswordStatus from '../components/ChangePasswordStatus';
import CheckoutDetails from '../components/CheckoutDetails';
import CheckoutLogin from '../components/CheckoutLogin';
import CheckoutPage from '../components/CheckoutPage';
import CodeInjection from '../components/CodeInjection';
import ContactUs from '../components/ContactUs';
import ContentBlock from '../components/ContentBlock';
import Cookie from '../components/Cookie';
import CreditCard from '../components/CreditCard';
import CustomButton from '../components/CustomButton';
import CustomTooltip from '../components/CustomTooltip';
import DialogComponent from '../components/DialogComponent';
import DigitalDelivery from '../components/DigitalDelivery';
import DrilldownMenu from '../components/DrilldownMenu';
import EULA from '../components/EULA';
import ExternalPaymentProcessing from '../components/ExternalPaymentProcessing';
import Footer from '../components/Footer';
import FourColumnContentRow from '../components/FourColumnContentRow';
import GlobalSearchField from '../components/GlobalSearchField';
import Header from '../components/Header';
import HeaderBanner from '../components/HeaderBanner';
import HeaderMenu from '../components/HeaderMenu';
import HelpfulTipsPage from '../components/HelpfulTipsPage';
import HeroBannerWithSearch from '../components/HeroBannerWithSearch';
import LandingPage from '../components/LandingPage';
import LatestNews from '../components/LatestNews';
import LinkRenderer from '../components/LinkRenderer';
import LoadingIcon from '../components/LoadingIcon';
import LoadingSection from '../components/LoadingSection';
import LoadingSkeleton from '../components/LoadingSkeleton';
import Login from '../components/Login';
import Logo from '../components/Logo';
import ManageAssignments from '../components/ManageAssignments';
import ManageUsers from '../components/ManageUsers';
import MarketingPromo from '../components/MarketingPromo';
import MobileNavigation from '../components/MobileNavigation';
import LinkList from '../components/Navigation/LinkList';
import ScrollToTop from '../components/Navigation/ScrollToTop';
import OneColumnContentRowFullWidth from '../components/OneColumnContentRowFullWidth';
import OneColumnContentRowWithMargins from '../components/OneColumnContentRowWithMargins';
import OptInNotification from '../components/OptInNotification';
import OrderConfirmation from '../components/OrderConfirmation';
import OrderHistory from '../components/OrderHistory';
import OrderPending from '../components/OrderPending';
import OrderProcessing from '../components/OrderProcessing';
import OrderSummary from '../components/OrderSummary';
import OrderSummaryCheckout from '../components/OrderSummaryCheckout';
import OrderUnsuccessful from '../components/OrderUnsuccessful';
import PageHero from '../components/PageHero';
import PaymentMethod from '../components/PaymentMethod';
import PaymentReceipt from '../components/PaymentReceipt';
import PlaceOrderProcess from '../components/PlaceOrderProcess';
import PreviewStandardImage from '../components/PreviewStandardImage';
import PreviousEditionsSection from '../components/PreviousEditionsSection';
import PreviousYearSection from '../components/PreviousYearSection';
import PriceOptions from '../components/PriceOptions';
import ProductCartDetails from '../components/ProductCartDetails';
import ProductDescriptionSection from '../components/ProductDescriptionSection';
import ProductDetails from '../components/ProductDetails';
import ProductMetaData from '../components/ProductMetaData';
import ProductSalesPrice from '../components/ProductSalesPrice';
import PromotionalBanner from '../components/PromotionalBanner';
import Quantity from '../components/Quantity';
import RecipientEmail from '../components/RecipientEmail';
import RelatedPrograms from '../components/RelatedPrograms';
import ResponsiveImage from '../components/ResponsiveImage';
import ReturnReceipt from '../components/ReturnReceipt';
import ReviewCartOrder from '../components/ReviewCartOrder';
import RichTextEditor from '../components/RichTextEditor';
import RichToastNotification from '../components/RichToastNotification';
import SearchField from '../components/SearchField';
import SearchPage from '../components/SearchPage';
import SecondaryHeaderMenu from '../components/SecondaryHeaderMenu';
import SectionFullWidth from '../components/SectionFullWidth';
import SectionWithMargin from '../components/SectionWithMargin';
import ShareLinkDialog from '../components/ShareLinkDialog';
import ShippingInformation from '../components/ShippingInformation';
import SignoutPage from '../components/SignoutPage';
import SkipToContent from '../components/SkipToContent';
import SocialFooter from '../components/SocialFooter';
import StatisticsStore from '../components/StatisticsStore';
import StatisticsStoreMenu from '../components/StatisticsStoreMenu';
import StatisticsStorePage from '../components/StatisticsStorePage';
import OneColumn from '../components/SubLayouts/OneColumn';
import TwoColumnwithLeftNav from '../components/SubLayouts/TwoColumnwithLeftNav';
import SubscriptionBanner from '../components/SubscriptionBanner';
import SubscriptionDetailsPage from '../components/SubscriptionDetailsPage';
import SubscriptionGlobalSearchField from '../components/SubscriptionGlobalSearchField';
import SubscriptionHeroBannerWithSearch from '../components/SubscriptionHeroBannerWithSearch';
import SubscriptionLanguageOptions from '../components/SubscriptionLanguageOptions';
import SubscriptionLogo from '../components/SubscriptionLogo';
import SubscriptionProductDetails from '../components/SubscriptionProductDetails';
import SubscriptionSearchField from '../components/SubscriptionSearchField';
import SubscriptionSearchPage from '../components/SubscriptionSearchPage';
import SubscriptionStandardOption from '../components/SubscriptionStandardOption';
import SubscriptionValidation from '../components/SubscriptionValidation';
import TaxExemptStatus from '../components/TaxExemptStatus';
import ThreeColumnContentRow from '../components/ThreeColumnContentRow';
import ToastNotification from '../components/ToastNotification';
import TrendingStandards from '../components/TrendingStandards';
import TwitterWidget from '../components/TwitterWidget';
import TwoColumnContentRow from '../components/TwoColumnContentRow';
import UploadTaxExempt from '../components/UploadTaxExempt';
import WebstoreRetailHelpfulTips from '../components/WebstoreRetailHelpfulTips';

const components = new Map();
components.set('AccountInfo', AccountInfo);
components.set('AddendaErrataSection', AddendaErrataSection);
components.set('AddNewAddress', AddNewAddress);
components.set('Auth', Auth);
components.set('BackToTopButton', BackToTopButton);
components.set('Cart', Cart);
components.set('CartDisclaimer', CartDisclaimer);
components.set('CartPage', CartPage);
components.set('CartSlider', CartSlider);
components.set('ChangePassword', ChangePassword);
components.set('ChangePasswordStatus', ChangePasswordStatus);
components.set('CheckoutDetails', CheckoutDetails);
components.set('CheckoutLogin', CheckoutLogin);
components.set('CheckoutPage', CheckoutPage);
components.set('CodeInjection', CodeInjection);
components.set('ContactUs', ContactUs);
components.set('ContentBlock', ContentBlock);
components.set('Cookie', Cookie);
components.set('CreditCard', CreditCard);
components.set('CustomButton', CustomButton);
components.set('CustomTooltip', CustomTooltip);
components.set('DialogComponent', DialogComponent);
components.set('DigitalDelivery', DigitalDelivery);
components.set('DrilldownMenu', DrilldownMenu);
components.set('EULA', EULA);
components.set('ExternalPaymentProcessing', ExternalPaymentProcessing);
components.set('Footer', Footer);
components.set('FourColumnContentRow', FourColumnContentRow);
components.set('GlobalSearchField', GlobalSearchField);
components.set('Header', Header);
components.set('HeaderBanner', HeaderBanner);
components.set('HeaderMenu', HeaderMenu);
components.set('HelpfulTipsPage', HelpfulTipsPage);
components.set('HeroBannerWithSearch', HeroBannerWithSearch);
components.set('LandingPage', LandingPage);
components.set('LatestNews', LatestNews);
components.set('LinkRenderer', LinkRenderer);
components.set('LoadingIcon', LoadingIcon);
components.set('LoadingSection', LoadingSection);
components.set('LoadingSkeleton', LoadingSkeleton);
components.set('Login', Login);
components.set('Logo', Logo);
components.set('ManageAssignments', ManageAssignments);
components.set('ManageUsers', ManageUsers);
components.set('MarketingPromo', MarketingPromo);
components.set('MobileNavigation', MobileNavigation);
components.set('LinkList', LinkList);
components.set('ScrollToTop', ScrollToTop);
components.set('OneColumnContentRowFullWidth', OneColumnContentRowFullWidth);
components.set('OneColumnContentRowWithMargins', OneColumnContentRowWithMargins);
components.set('OptInNotification', OptInNotification);
components.set('OrderConfirmation', OrderConfirmation);
components.set('OrderHistory', OrderHistory);
components.set('OrderPending', OrderPending);
components.set('OrderProcessing', OrderProcessing);
components.set('OrderSummary', OrderSummary);
components.set('OrderSummaryCheckout', OrderSummaryCheckout);
components.set('OrderUnsuccessful', OrderUnsuccessful);
components.set('PageHero', PageHero);
components.set('PaymentMethod', PaymentMethod);
components.set('PaymentReceipt', PaymentReceipt);
components.set('PlaceOrderProcess', PlaceOrderProcess);
components.set('PreviewStandardImage', PreviewStandardImage);
components.set('PreviousEditionsSection', PreviousEditionsSection);
components.set('PreviousYearSection', PreviousYearSection);
components.set('PriceOptions', PriceOptions);
components.set('ProductCartDetails', ProductCartDetails);
components.set('ProductDescriptionSection', ProductDescriptionSection);
components.set('ProductDetails', ProductDetails);
components.set('ProductMetaData', ProductMetaData);
components.set('ProductSalesPrice', ProductSalesPrice);
components.set('PromotionalBanner', PromotionalBanner);
components.set('Quantity', Quantity);
components.set('RecipientEmail', RecipientEmail);
components.set('RelatedPrograms', RelatedPrograms);
components.set('ResponsiveImage', ResponsiveImage);
components.set('ReturnReceipt', ReturnReceipt);
components.set('ReviewCartOrder', ReviewCartOrder);
components.set('RichTextEditor', RichTextEditor);
components.set('RichToastNotification', RichToastNotification);
components.set('SearchField', SearchField);
components.set('SearchPage', SearchPage);
components.set('SecondaryHeaderMenu', SecondaryHeaderMenu);
components.set('SectionFullWidth', SectionFullWidth);
components.set('SectionWithMargin', SectionWithMargin);
components.set('ShareLinkDialog', ShareLinkDialog);
components.set('ShippingInformation', ShippingInformation);
components.set('SignoutPage', SignoutPage);
components.set('SkipToContent', SkipToContent);
components.set('SocialFooter', SocialFooter);
components.set('StatisticsStore', StatisticsStore);
components.set('StatisticsStoreMenu', StatisticsStoreMenu);
components.set('StatisticsStorePage', StatisticsStorePage);
components.set('OneColumn', OneColumn);
components.set('TwoColumnwithLeftNav', TwoColumnwithLeftNav);
components.set('SubscriptionBanner', SubscriptionBanner);
components.set('SubscriptionDetailsPage', SubscriptionDetailsPage);
components.set('SubscriptionGlobalSearchField', SubscriptionGlobalSearchField);
components.set('SubscriptionHeroBannerWithSearch', SubscriptionHeroBannerWithSearch);
components.set('SubscriptionLanguageOptions', SubscriptionLanguageOptions);
components.set('SubscriptionLogo', SubscriptionLogo);
components.set('SubscriptionProductDetails', SubscriptionProductDetails);
components.set('SubscriptionSearchField', SubscriptionSearchField);
components.set('SubscriptionSearchPage', SubscriptionSearchPage);
components.set('SubscriptionStandardOption', SubscriptionStandardOption);
components.set('SubscriptionValidation', SubscriptionValidation);
components.set('TaxExemptStatus', TaxExemptStatus);
components.set('ThreeColumnContentRow', ThreeColumnContentRow);
components.set('ToastNotification', ToastNotification);
components.set('TrendingStandards', TrendingStandards);
components.set('TwitterWidget', TwitterWidget);
components.set('TwoColumnContentRow', TwoColumnContentRow);
components.set('UploadTaxExempt', UploadTaxExempt);
components.set('WebstoreRetailHelpfulTips', WebstoreRetailHelpfulTips);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
